import React, { Suspense, lazy } from "react";
import "./css/styles.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { NotificationContainer } from "react-notifications";

import SkeletonLoading from "./components/SkeletonLoading";

// ✅ ADD THESE (adjust paths if needed)
const SignIn = lazy(() => import("./components/SignIn"));
const AdminPanel = lazy(() => import("./components/AdminPanel"));
const ProtectedRoute = lazy(() => import("./components/ProtectedRoute"));
const Dashboard = lazy(() => import("./components/Dashboard"));
const VerifyReceipt = lazy(() => import("./components/VerifyReceipt"));
const Home = lazy(() => import("./components/Home"));
const GenerateInvoice = lazy(() => import("./components/GenerateInvoice"));
const Payment = lazy(() => import("./components/public/Payment"));
const TransferDetails = lazy(() => import("./components/public/TransferDetails"));
const InvoiceSummary = lazy(() => import("./components/InvoiceSummary"));
const Receipt = lazy(() => import("./components/public/Receipt"));
const Contact = lazy(() => import("./components/Contact"));
const AdminDashboard = lazy(() => import("./components/AdminDashboard"));

function App() {
  return (
    <div>
      <Router>
        <Suspense fallback={<SkeletonLoading />}>
          <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/generate-invoice" element={<GenerateInvoice />} />
          <Route path="/invoice-summary" element={<InvoiceSummary />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/transfer-details" element={<TransferDetails />} />
          <Route path="/receipt" element={<Receipt />} />
          <Route path="/verify-receipt" element={<VerifyReceipt />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/adminDashboard" element={<AdminDashboard />} />

          {/* Auth */}
          <Route path="/login" element={<SignIn />} />

          {/* Protected */}
          <Route
            path="/panel"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          </Routes>
        </Suspense>
      </Router>

      <NotificationContainer />
    </div>
  );
}

export default App;
